import React, { useEffect, useRef, useState } from "react";
import "./Sidebar.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import axios from "axios";
// import img from '../../../../public/assets/images/DashboardImages/icons/user.png'

const Sidebar = ({ isSidebarOpen, dropdownRefSideBar }) => {
  const navigate = useNavigate();

  const [openSidebar, setOpenSidebar] = useState();

  const [Data , setData] = useState()
  useEffect(() => {
    const fetchData = async () => {
      try {
        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: `${process.env.REACT_APP_API_URL2}/customer/getCustomerById`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
  
        const response = await axios.request(config);
        console.log("First Name:", response.data.firstName); // Log the first name
        setData(response.data); // Set the fetched data in state
      } catch (error) {
        console.error("Error fetching data:", error); 
        if (error.response?.data?.success === false) {
          // Redirect to login page
          navigate('/login');
        }// Handle errors
      }
    };
  
    fetchData();
  }, []);

  const handleUpgrade = () => {
    navigate('/settings');  // Replace '/pro' with the path you want to navigate to
  };


  useEffect(() => {
    setOpenSidebar(isSidebarOpen);
  }, [isSidebarOpen]);
  return (
    <div
      className={`sidebar-main-container h-screen sidebar ${
        openSidebar ? "open" : ""
      }`}
      ref={dropdownRefSideBar}
    >
      <div>
        <div className="sidebar-logo-container">
          <img src="../../../../dashlogo.svg" alt="" />
        </div>

        <div className="sidebar-options-container">
          <ul>
            <li>
              <NavLink
                to="/dashboard"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  className="dashLinkicon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M16.6665 8.33334C16.6665 8.11232 16.5787 7.90036 16.4224 7.74408C16.2661 7.5878 16.0542 7.5 15.8332 7.5C15.6121 7.5 15.4002 7.5878 15.2439 7.74408C15.0876 7.90036 14.9998 8.11232 14.9998 8.33334H16.6665ZM4.99982 8.33334C4.99982 8.11232 4.91203 7.90036 4.75575 7.74408C4.59947 7.5878 4.3875 7.5 4.16649 7.5C3.94548 7.5 3.73351 7.5878 3.57723 7.74408C3.42095 7.90036 3.33316 8.11232 3.33316 8.33334H4.99982ZM16.9107 10.5892C17.0678 10.741 17.2783 10.825 17.4968 10.8231C17.7153 10.8212 17.9243 10.7335 18.0788 10.579C18.2333 10.4245 18.321 10.2155 18.3229 9.997C18.3248 9.77851 18.2408 9.568 18.089 9.41084L16.9107 10.5892ZM9.99982 2.5L10.589 1.91084C10.4327 1.75461 10.2208 1.66685 9.99982 1.66685C9.77885 1.66685 9.56693 1.75461 9.41066 1.91084L9.99982 2.5ZM1.91066 9.41084C1.83106 9.48771 1.76758 9.57966 1.72391 9.68133C1.68023 9.783 1.65724 9.89235 1.65628 10.003C1.65532 10.1137 1.6764 10.2234 1.71831 10.3258C1.76021 10.4282 1.82208 10.5213 1.90033 10.5995C1.97857 10.6777 2.07161 10.7396 2.17403 10.7815C2.27644 10.8234 2.38618 10.8445 2.49682 10.8435C2.60747 10.8426 2.71682 10.8196 2.81849 10.7759C2.92016 10.7322 3.01212 10.6688 3.08899 10.5892L1.91066 9.41084ZM5.83316 18.3333H14.1665V16.6667H5.83316V18.3333ZM16.6665 15.8333V8.33334H14.9998V15.8333H16.6665ZM4.99982 15.8333V8.33334H3.33316V15.8333H4.99982ZM18.089 9.41084L10.589 1.91084L9.41066 3.08917L16.9107 10.5892L18.089 9.41084ZM9.41066 1.91084L1.91066 9.41084L3.08899 10.5892L10.589 3.08917L9.41066 1.91084ZM14.1665 18.3333C14.8295 18.3333 15.4654 18.0699 15.9343 17.6011C16.4031 17.1323 16.6665 16.4964 16.6665 15.8333H14.9998C14.9998 16.0543 14.912 16.2663 14.7557 16.4226C14.5995 16.5789 14.3875 16.6667 14.1665 16.6667V18.3333ZM5.83316 16.6667C5.61214 16.6667 5.40018 16.5789 5.2439 16.4226C5.08762 16.2663 4.99982 16.0543 4.99982 15.8333H3.33316C3.33316 16.4964 3.59655 17.1323 4.06539 17.6011C4.53423 18.0699 5.17012 18.3333 5.83316 18.3333V16.6667Z"
                    fill="black"
                  />
                </svg>
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/livechat"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M10.0001 12.5131C9.44509 12.5131 8.97447 12.1513 8.81134 11.6506C8.74884 11.4575 8.91259 11.2631 9.11572 11.2631H10.8851C11.0882 11.2631 11.252 11.4581 11.1895 11.6506C11.0257 12.1506 10.5551 12.5131 10.0001 12.5131Z"
                    fill="#343434"
                  />
                  <path
                    d="M7.1875 14.7006H6.25C5.38687 14.7006 4.6875 14.0006 4.6875 13.1381V7.51313C4.6875 6.65001 5.38687 5.95063 6.25 5.95063H13.75C14.6131 5.95063 15.3125 6.65001 15.3125 7.51313V13.1381C15.3125 14.0006 14.6131 14.7006 13.75 14.7006H9.0625L7.8125 16.5756"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path d="M7.5 10.9506V10.3256V10.9506Z" fill="#343434" />
                  <path
                    d="M7.5 10.9506V10.3256"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path d="M12.5 10.3256V10.9506V10.3256Z" fill="#343434" />
                  <path
                    d="M12.5 10.3256V10.9506"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.1875 10.625V8.75001C17.1875 4.78063 13.9694 1.56251 10 1.56251C6.03063 1.56251 2.8125 4.78063 2.8125 8.75001V11.875"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.8125 13.4375C17.4687 13.4375 17.1875 13.1563 17.1875 12.8125V9.68751C17.1875 9.34376 17.4687 9.06251 17.8125 9.06251C18.1563 9.06251 18.4687 9.20001 18.6937 9.43126C18.925 9.65626 19.0625 9.96876 19.0625 10.3125V12.1875C19.0625 12.875 18.5 13.4375 17.8125 13.4375Z"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.1875 13.4375C2.53125 13.4375 2.8125 13.1563 2.8125 12.8125V9.68751C2.8125 9.34376 2.53125 9.06251 2.1875 9.06251C1.84375 9.06251 1.53125 9.20001 1.30625 9.43126C1.075 9.65626 0.9375 9.96876 0.9375 10.3125V12.1875C0.9375 12.875 1.5 13.4375 2.1875 13.4375Z"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.5625 17.8125H13.75C15.6488 17.8125 17.1875 16.2738 17.1875 14.375"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.9375 18.4375H9.6875C9.34375 18.4375 9.0625 18.1563 9.0625 17.8125C9.0625 17.4688 9.34375 17.1875 9.6875 17.1875H10.9375C11.2813 17.1875 11.5625 17.4688 11.5625 17.8125C11.5625 18.1563 11.2813 18.4375 10.9375 18.4375Z"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.1875 14.7006H6.25C5.38687 14.7006 4.6875 14.0006 4.6875 13.1381V7.51313C4.6875 6.65001 5.38687 5.95063 6.25 5.95063H13.75C14.6131 5.95063 15.3125 6.65001 15.3125 7.51313V13.1381C15.3125 14.0006 14.6131 14.7006 13.75 14.7006H9.0625L7.8125 16.5756"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.5 10.9506V10.3256"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.5 10.3256V10.9506"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.1875 10.625V8.75001C17.1875 4.78063 13.9694 1.56251 10 1.56251C6.03063 1.56251 2.8125 4.78063 2.8125 8.75001V11.875"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.8125 13.4375C17.4687 13.4375 17.1875 13.1563 17.1875 12.8125V9.68751C17.1875 9.34376 17.4687 9.06251 17.8125 9.06251C18.1563 9.06251 18.4687 9.20001 18.6937 9.43126C18.925 9.65626 19.0625 9.96876 19.0625 10.3125V12.1875C19.0625 12.875 18.5 13.4375 17.8125 13.4375Z"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.1875 13.4375C2.53125 13.4375 2.8125 13.1563 2.8125 12.8125V9.68751C2.8125 9.34376 2.53125 9.06251 2.1875 9.06251C1.84375 9.06251 1.53125 9.20001 1.30625 9.43126C1.075 9.65626 0.9375 9.96876 0.9375 10.3125V12.1875C0.9375 12.875 1.5 13.4375 2.1875 13.4375Z"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.5625 17.8125H13.75C15.6488 17.8125 17.1875 16.2738 17.1875 14.375"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M10.9375 18.4375H9.6875C9.34375 18.4375 9.0625 18.1563 9.0625 17.8125C9.0625 17.4688 9.34375 17.1875 9.6875 17.1875H10.9375C11.2813 17.1875 11.5625 17.4688 11.5625 17.8125C11.5625 18.1563 11.2813 18.4375 10.9375 18.4375Z"
                    stroke="#343434"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Live Chats</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/KnowledgeLibrary"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M5.83319 12.4188C5.46943 12.4193 5.11016 12.4992 4.78048 12.6529C4.45079 12.8067 4.15862 13.0305 3.92435 13.3088C3.69009 13.587 3.51938 13.9131 3.42413 14.2642C3.32889 14.6153 3.3114 14.9829 3.3729 15.3414C3.4344 15.6999 3.57339 16.0407 3.78019 16.34C3.98698 16.6393 4.2566 16.8898 4.57021 17.0741C4.88382 17.2584 5.23387 17.3721 5.59594 17.4071C5.95801 17.4422 6.32337 17.3978 6.66652 17.2771"
                    stroke="#343434"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M3.55342 13.7563C3.05473 13.5162 2.62366 13.1557 2.29913 12.7073C1.97461 12.259 1.76683 11.7369 1.69456 11.1881C1.62228 10.6394 1.68779 10.0813 1.88516 9.56419C2.08254 9.0471 2.40556 8.58729 2.82509 8.22627M2.85009 8.15876C2.57679 7.74981 2.45701 7.25734 2.51194 6.76854C2.56687 6.27974 2.79298 5.82615 3.15024 5.48805C3.50749 5.14996 3.97285 4.94917 4.46393 4.92124C4.95501 4.89331 5.44014 5.04003 5.83342 5.33543M6.03176 5.3896C5.89882 5.10714 5.83106 4.79841 5.83349 4.48623C5.83592 4.17406 5.90847 3.86643 6.04579 3.58606C6.1831 3.3057 6.38167 3.05979 6.62681 2.86649C6.87196 2.6732 7.15741 2.53747 7.46206 2.46933C7.76672 2.4012 8.08279 2.4024 8.38692 2.47285C8.69105 2.5433 8.97546 2.68121 9.21912 2.87636C9.46278 3.07152 9.65947 3.31894 9.79465 3.60034C9.92983 3.88174 10 4.18992 10.0001 4.5021M10.0001 4.5021V17.4188M10.0001 4.5021C10.0001 4.18992 10.0704 3.88174 10.2055 3.60034C10.3407 3.31894 10.5374 3.07152 10.7811 2.87636C11.0247 2.68121 11.3091 2.5433 11.6133 2.47285C11.9174 2.4024 12.2335 2.4012 12.5381 2.46933C12.8428 2.53747 13.1282 2.6732 13.3734 2.86649C13.6185 3.05979 13.8171 3.3057 13.9544 3.58606C14.0917 3.86643 14.1643 4.17406 14.1667 4.48623C14.1691 4.79841 14.1014 5.10714 13.9684 5.3896M10.0001 17.4188C10.0001 17.8608 9.8245 18.2847 9.51193 18.5973C9.19937 18.9098 8.77545 19.0854 8.33342 19.0854C7.8914 19.0854 7.46747 18.9098 7.15491 18.5973C6.84235 18.2847 6.66676 17.8608 6.66676 17.4188M10.0001 17.4188C10.0001 17.8608 10.1757 18.2847 10.4882 18.5973C10.8008 18.9098 11.2247 19.0854 11.6668 19.0854M10.0001 6.58543C10.0001 7.24847 10.2635 7.88436 10.7323 8.3532C11.2012 8.82204 11.837 9.08543 12.5001 9.08543M17.1751 8.22627C17.5389 8.53882 17.8308 8.92639 18.0308 9.36238C18.2307 9.79836 18.334 10.2725 18.3334 10.7521C18.3334 11.3379 18.1826 11.8888 17.9168 12.3671M17.1501 8.15876C17.4234 7.74981 17.5432 7.25734 17.4882 6.76854C17.4333 6.27974 17.2072 5.82615 16.8499 5.48805C16.4927 5.14996 16.0273 4.94917 15.5363 4.92124C15.0452 4.89331 14.56 5.04003 14.1668 5.33543M17.0834 17.8354L18.3334 19.0854M13.3334 16.1688C13.3334 16.7213 13.5529 17.2512 13.9436 17.6419C14.3343 18.0326 14.8642 18.2521 15.4168 18.2521C15.9693 18.2521 16.4992 18.0326 16.8899 17.6419C17.2806 17.2512 17.5001 16.7213 17.5001 16.1688C17.5001 15.6162 17.2806 15.0863 16.8899 14.6956C16.4992 14.3049 15.9693 14.0854 15.4168 14.0854C14.8642 14.0854 14.3343 14.3049 13.9436 14.6956C13.5529 15.0863 13.3334 15.6162 13.3334 16.1688Z"
                    stroke="#343434"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Ai Training</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/Integration"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M16.6667 6.58546H14.8742C14.4583 6.58546 14.1667 6.16713 14.1667 5.75213C14.1667 5.42382 14.102 5.09873 13.9764 4.79542C13.8507 4.49211 13.6666 4.21651 13.4344 3.98436C13.2023 3.75222 12.9267 3.56807 12.6234 3.44243C12.3201 3.31679 11.995 3.25213 11.6667 3.25213C11.3384 3.25213 11.0133 3.31679 10.71 3.44243C10.4066 3.56807 10.131 3.75222 9.8989 3.98436C9.66675 4.21651 9.4826 4.49211 9.35697 4.79542C9.23133 5.09873 9.16667 5.42382 9.16667 5.75213C9.16667 6.16713 8.87417 6.58546 8.45917 6.58546H6.66667C6.44565 6.58546 6.23369 6.67326 6.07741 6.82954C5.92113 6.98582 5.83333 7.19778 5.83333 7.4188V9.2113C5.83333 9.62713 5.415 9.9188 5 9.9188C4.6717 9.9188 4.34661 9.98346 4.04329 10.1091C3.73998 10.2347 3.46438 10.4189 3.23223 10.651C3.00009 10.8832 2.81594 11.1588 2.6903 11.4621C2.56466 11.7654 2.5 12.0905 2.5 12.4188C2.5 12.7471 2.56466 13.0722 2.6903 13.3755C2.81594 13.6788 3.00009 13.9544 3.23223 14.1866C3.46438 14.4187 3.73998 14.6029 4.04329 14.7285C4.34661 14.8541 4.6717 14.9188 5 14.9188C5.415 14.9188 5.83333 15.2113 5.83333 15.6263V17.4188C5.83333 17.6398 5.92113 17.8518 6.07741 18.0081C6.23369 18.1643 6.44565 18.2521 6.66667 18.2521H16.6667C16.8877 18.2521 17.0996 18.1643 17.2559 18.0081C17.4122 17.8518 17.5 17.6398 17.5 17.4188V15.6263C17.5 15.2113 17.0808 14.9188 16.6667 14.9188C16.3384 14.9188 16.0133 14.8541 15.71 14.7285C15.4066 14.6029 15.131 14.4187 14.8989 14.1866C14.6668 13.9544 14.4826 13.6788 14.357 13.3755C14.2313 13.0722 14.1667 12.7471 14.1667 12.4188C14.1667 12.0905 14.2313 11.7654 14.357 11.4621C14.4826 11.1588 14.6668 10.8832 14.8989 10.651C15.131 10.4189 15.4066 10.2347 15.71 10.1091C16.0133 9.98346 16.3384 9.9188 16.6667 9.9188C17.0808 9.9188 17.5 9.6263 17.5 9.2113V7.4188C17.5 7.19778 17.4122 6.98582 17.2559 6.82954C17.0996 6.67326 16.8877 6.58546 16.6667 6.58546Z"
                    stroke="#343434"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Integration</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/callLogs"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2147_7619)">
                    <path
                      d="M9.9987 18.3333H4.16536C3.94435 18.3333 3.73239 18.2455 3.57611 18.0892C3.41983 17.933 3.33203 17.721 3.33203 17.5V2.49997C3.33203 2.27896 3.41983 2.067 3.57611 1.91072C3.73239 1.75444 3.94435 1.66664 4.16536 1.66664H15.832C16.053 1.66664 16.265 1.75444 16.4213 1.91072C16.5776 2.067 16.6654 2.27896 16.6654 2.49997V9.99997M14.7904 18.3333V12.9166"
                      stroke="#343434"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.916 14.375L13.541 13.75L14.791 12.5L16.041 13.75L16.666 14.375"
                      stroke="#343434"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M6.66602 6.66664H13.3327M6.66602 9.99997H9.99935"
                      stroke="#343434"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2147_7619">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>Call Logs</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/analytics"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <g clip-path="url(#clip0_2147_7631)">
                    <path
                      d="M19.6094 19.2189H19.1406V5.47116C19.1406 5.25542 18.9657 5.08054 18.75 5.08054H16.25C16.0343 5.08054 15.8594 5.25542 15.8594 5.47116V11.0679C15.8594 11.2836 16.0343 11.4585 16.25 11.4585C16.4657 11.4585 16.6406 11.2836 16.6406 11.0679V5.86179H18.3594V19.2189H16.6406V14.1538C16.6406 13.938 16.4657 13.7632 16.25 13.7632C16.0343 13.7632 15.8594 13.938 15.8594 14.1538V19.2189H14.1406V11.2892C14.1406 11.0735 13.9657 10.8986 13.75 10.8986H11.25C11.0343 10.8986 10.8594 11.0735 10.8594 11.2892V19.2189H9.14062V7.89077C9.14062 7.67503 8.9657 7.50015 8.75 7.50015H6.25C6.0343 7.50015 5.85938 7.67503 5.85938 7.89077V19.2189H4.14062V13.2814C4.14062 13.0657 3.9657 12.8908 3.75 12.8908H1.25C1.0343 12.8908 0.859375 13.0657 0.859375 13.2814V19.2189H0.390625C0.174922 19.2189 0 19.3938 0 19.6095C0 19.8253 0.174922 20.0001 0.390625 20.0001H19.6094C19.8251 20.0001 20 19.8253 20 19.6095C20 19.3938 19.8251 19.2189 19.6094 19.2189ZM3.35938 19.2189H1.64062V13.672H3.35938V19.2189ZM8.35938 19.2189H6.64062V8.2814H8.35938V19.2189ZM13.3594 19.2189H11.6406V11.6798H13.3594V19.2189Z"
                      fill="#343434"
                    />
                    <path
                      d="M16.5261 12.2642C16.4535 12.1915 16.3527 12.1497 16.25 12.1497C16.1473 12.1497 16.0465 12.1915 15.9738 12.2642C15.9012 12.3369 15.8594 12.4376 15.8594 12.5404C15.8594 12.6431 15.9011 12.7439 15.9738 12.8165C16.0465 12.8892 16.1473 12.931 16.25 12.931C16.3527 12.931 16.4535 12.8892 16.5261 12.8165C16.5988 12.7439 16.6406 12.6431 16.6406 12.5404C16.6406 12.4376 16.5988 12.3369 16.5261 12.2642Z"
                      fill="#343434"
                    />
                    <path
                      d="M2.5 7.49088C1.72457 7.49088 1.09375 8.1217 1.09375 8.89713C1.09375 9.67255 1.72457 10.3034 2.5 10.3034C3.27543 10.3034 3.90625 9.67255 3.90625 8.89713C3.90625 8.1217 3.27543 7.49088 2.5 7.49088ZM2.5 9.52213C2.15539 9.52213 1.875 9.24173 1.875 8.89713C1.875 8.55252 2.15539 8.27213 2.5 8.27213C2.84461 8.27213 3.125 8.55252 3.125 8.89713C3.125 9.24173 2.84461 9.52213 2.5 9.52213Z"
                      fill="#343434"
                    />
                    <path
                      d="M17.4998 0.000137329C16.7244 0.000137329 16.0936 0.630958 16.0936 1.40639C16.0936 1.65236 16.1572 1.88369 16.2687 2.08506L13.1785 5.17525C12.9771 5.06381 12.7458 5.00014 12.4998 5.00014C12.1974 5.00014 11.9171 5.09647 11.6875 5.25959L8.79958 2.95826C8.86806 2.79291 8.90606 2.61182 8.90606 2.42201C8.90606 1.64658 8.27524 1.01576 7.49981 1.01576C6.72439 1.01576 6.09356 1.64658 6.09356 2.42201C6.09356 2.73221 6.1947 3.01908 6.36548 3.25186L4.6088 5.52678C4.47696 5.69756 4.50849 5.94287 4.67927 6.07471C4.75032 6.12959 4.83435 6.15615 4.91771 6.15615C5.03458 6.15615 5.15017 6.10393 5.22716 6.00424L6.98356 3.72963C7.14353 3.79303 7.31759 3.82826 7.49981 3.82826C7.80228 3.82826 8.08251 3.73193 8.31212 3.56885L11.2 5.87018C11.1316 6.03553 11.0936 6.21658 11.0936 6.40639C11.0936 7.18182 11.7244 7.81264 12.4998 7.81264C13.2752 7.81264 13.9061 7.18182 13.9061 6.40639C13.9061 6.16041 13.8424 5.92908 13.7309 5.72772L16.8211 2.63752C17.0225 2.74897 17.2538 2.81264 17.4998 2.81264C18.2752 2.81264 18.9061 2.18182 18.9061 1.40639C18.9061 0.630958 18.2752 0.000137329 17.4998 0.000137329ZM7.49981 3.04701C7.15521 3.04701 6.87481 2.76662 6.87481 2.42201C6.87481 2.0774 7.15521 1.79701 7.49981 1.79701C7.84442 1.79701 8.12481 2.0774 8.12481 2.42201C8.12481 2.76662 7.84442 3.04701 7.49981 3.04701ZM12.4998 7.03139C12.1552 7.03139 11.8748 6.751 11.8748 6.40639C11.8748 6.06178 12.1552 5.78139 12.4998 5.78139C12.8444 5.78139 13.1248 6.06178 13.1248 6.40639C13.1248 6.751 12.8444 7.03139 12.4998 7.03139ZM17.4998 2.03139C17.1552 2.03139 16.8748 1.751 16.8748 1.40639C16.8748 1.06178 17.1552 0.781387 17.4998 0.781387C17.8444 0.781387 18.1248 1.06178 18.1248 1.40639C18.1248 1.751 17.8444 2.03139 17.4998 2.03139Z"
                      fill="#343434"
                    />
                    <path
                      d="M4.24443 6.71966C4.17139 6.64701 4.071 6.60521 3.96787 6.60521C3.86514 6.60521 3.76475 6.64701 3.6917 6.71966C3.61904 6.79232 3.57764 6.8931 3.57764 6.99583C3.57764 7.09857 3.61904 7.19935 3.6917 7.27201C3.76475 7.34466 3.86514 7.38646 3.96787 7.38646C4.071 7.38646 4.17139 7.34466 4.24443 7.27201C4.31705 7.19935 4.3585 7.09857 4.3585 6.99583C4.3585 6.8931 4.31705 6.79232 4.24443 6.71966Z"
                      fill="#343434"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_2147_7631">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <span>Analytics</span>
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/settings"
                className="dashLinks flex items-center"
                activeClassName="active"
                onClick={() => setOpenSidebar(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                >
                  <path
                    d="M7.70833 19.0854L7.375 16.4187C7.19444 16.3493 7.02444 16.266 6.865 16.1687C6.70556 16.0715 6.54917 15.9673 6.39583 15.8562L3.91667 16.8979L1.625 12.9396L3.77083 11.3146C3.75694 11.2173 3.75 11.1237 3.75 11.0337V10.4712C3.75 10.3807 3.75694 10.2868 3.77083 10.1896L1.625 8.56456L3.91667 4.60623L6.39583 5.6479C6.54861 5.53679 6.70833 5.43262 6.875 5.3354C7.04167 5.23818 7.20833 5.15484 7.375 5.0854L7.70833 2.41873H12.2917L12.625 5.0854C12.8056 5.15484 12.9758 5.23818 13.1358 5.3354C13.2958 5.43262 13.4519 5.53679 13.6042 5.6479L16.0833 4.60623L18.375 8.56456L16.2292 10.1896C16.2431 10.2868 16.25 10.3807 16.25 10.4712V11.0329C16.25 11.1235 16.2361 11.2173 16.2083 11.3146L18.3542 12.9396L16.0625 16.8979L13.6042 15.8562C13.4514 15.9673 13.2917 16.0715 13.125 16.1687C12.9583 16.266 12.7917 16.3493 12.625 16.4187L12.2917 19.0854H7.70833ZM9.16667 17.4187H10.8125L11.1042 15.2104C11.5347 15.0993 11.9342 14.9362 12.3025 14.7212C12.6708 14.5062 13.0075 14.2457 13.3125 13.9396L15.375 14.7937L16.1875 13.3771L14.3958 12.0229C14.4653 11.8285 14.5139 11.6237 14.5417 11.4087C14.5694 11.1937 14.5833 10.9748 14.5833 10.7521C14.5833 10.5298 14.5694 10.3112 14.5417 10.0962C14.5139 9.88123 14.4653 9.67623 14.3958 9.48123L16.1875 8.12707L15.375 6.7104L13.3125 7.5854C13.0069 7.26595 12.6703 6.99873 12.3025 6.78373C11.9347 6.56873 11.5353 6.4054 11.1042 6.29373L10.8333 4.0854H9.1875L8.89583 6.29373C8.46528 6.40484 8.06611 6.56818 7.69833 6.78373C7.33056 6.99929 6.99361 7.25956 6.6875 7.56457L4.625 6.7104L3.8125 8.12707L5.60417 9.4604C5.53472 9.66873 5.48611 9.87706 5.45833 10.0854C5.43056 10.2937 5.41667 10.516 5.41667 10.7521C5.41667 10.9743 5.43056 11.1896 5.45833 11.3979C5.48611 11.6062 5.53472 11.8146 5.60417 12.0229L3.8125 13.3771L4.625 14.7937L6.6875 13.9187C6.99306 14.2382 7.33 14.5057 7.69833 14.7212C8.06667 14.9368 8.46583 15.0998 8.89583 15.2104L9.16667 17.4187ZM10.0417 13.6687C10.8472 13.6687 11.5347 13.384 12.1042 12.8146C12.6736 12.2451 12.9583 11.5576 12.9583 10.7521C12.9583 9.94651 12.6736 9.25901 12.1042 8.68956C11.5347 8.12012 10.8472 7.8354 10.0417 7.8354C9.22222 7.8354 8.53111 8.12012 7.96833 8.68956C7.40556 9.25901 7.12444 9.94651 7.125 10.7521C7.125 11.5576 7.40639 12.2451 7.96917 12.8146C8.53194 13.384 9.22278 13.6687 10.0417 13.6687Z"
                    fill="#343434"
                  />
                </svg>
                <span>Settings</span>
              </NavLink>
            </li>
            <hr
              style={{
                color: "red",
                backgroundColor: "#A890D3",
                height: "1.117px",
                border: "none",
                margin: "10px 0",
                opacity: 0.2,
              }}
            />
          </ul>
        </div>

        <div
          className="sidebar-accountSetting-container"
          onClick={() => navigate("/accountsettings")}
        >
          <div className="userImg-box flex">
            <img
              src="../../../../assets/images/DashboardImages/icons/Group 39488 (1).png"
              alt="user"
            />
          </div>
          <div className="accountSetting-text-box">
             <h6>{Data?.firstName || "Fabricare"}</h6>
            <p>Account settings</p>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 15 14"
            fill="none"
          >
            <g opacity="0.8">
              <path
                d="M5.87305 10.4626L9.22305 7.11256L5.87305 3.76256"
                stroke="#AEB9E1"
                stroke-width="0.893333"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </div>
      </div>

      
      <div className="sidebar-footer">>
 {Data?.BillingSubscription === 'free' && (
        <button className="themeGlow-btn" onClick={handleUpgrade}>
          Upgrade to Pro <Icon icon="ph:arrow-right" style={{ color: "#fff" }} />
        </button>
      )}
      <button className="themeGlow-btn" onClick={()=>{navigate("/login")}}>
      logout
      </button>
      </div>

    </div>
  );
};

export default Sidebar;
